module.exports = __webpack_public_path__ + "static/media/invoice_app_lg.94b17897.jpg";